module.exports = __webpack_public_path__ + "img/time.c1717cbf.png";